import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette, typography }) =>
  createStyles({
    container: {
      margin: '2rem 0.8rem',
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      flex: 1,

      '& h1': {
        fontWeight: 600,
      },
    },

    inputsContainer: {
      marginTop: '4rem',

      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',

      '& .MuiTextField-root': {
        margin: 0,
        width: '100%',
      },
    },

    menuList: {
      '& > li': {
        fontSize: '1.4rem',
        color: palette.secondary.main,
        padding: '1rem 1.4rem',
        lineHeight: '2rem',
      },
      '& .MuiListSubheader-root': {
        fontWeight: 600,
      },
    },

    textareaContainer: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',

      '& > div': {
        position: 'relative',
        flex: 1,

        '& > textarea': {
          width: '100%',
          height: '100%',
          minHeight: '10rem',
          padding: '1.6rem 1.4rem',

          resize: 'none',

          border: `1px solid ${palette.secondary.light}`,
          borderRadius: '0.4rem',

          fontFamily: typography.body1.fontFamily,
          fontSize: '1.6rem',
          color: palette.secondary.main,

          '&:focus': {
            outline: `1px solid ${palette.secondary.light}`,
          },

          '&[data-error="true"]': {
            borderColor: palette.error.main,

            '&:focus': {
              outline: `1px solid ${palette.error.main}`,
            },
          },
        },

        '& > span': {
          position: 'absolute',
          bottom: '0.6rem',
          right: '1.6rem',

          fontFamily: typography.body1.fontFamily,
          fontSize: '1.1rem',
          color: palette.secondary.main,
          fontWeight: 400,
          letterSpacing: '0.1em',

          '&[data-limit="true"]': {
            color: palette.error.main,
            fontWeight: 600,
          },
        },
      },

      '& > p': {
        marginLeft: '1.6rem',
      },
    },

    buttonsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '1rem',

      '& > button, & > a': {
        margin: 0,
        width: 'fit-content',
      },
    },
  }),
)
